import React, { useEffect, useState } from 'react';
import { SparklesIcon } from '../../icons/gamification';
import { useGamification } from '../../context/GamificationContext';

const XpGainNotification = () => {
  const { xpGained } = useGamification();
  const [visible, setVisible] = useState(false);
  const [xpAmount, setXpAmount] = useState(0);
  
  useEffect(() => {
    if (xpGained.visible && xpGained.amount > 0) {
      setXpAmount(xpGained.amount);
      setVisible(true);
      
      // This will auto remove the toast after the animation completes
      const timeout = setTimeout(() => {
        setVisible(false);
      }, 5000); // Match this with the CSS animation duration
      
      return () => clearTimeout(timeout);
    }
  }, [xpGained]);
  
  if (!visible) {
    return null;
  }
  
  return (
    <div className="xp-toast animate-fadeInOut">
      <SparklesIcon className="h-4 w-4" />
      <span>+{xpAmount} XP</span>
    </div>
  );
};

export default XpGainNotification;